export const getUserIdFromAuth = state => state.auth.user.user_id;
export const getFirstNameFromAuth = state => state.auth.user.first_name;
export const getLastNameFromAuth = state => state.auth.user.last_name;
export const getPortalIdFromAuth = state => state.auth.portal.portal_id;
export const getScopesFromAuth = state => state.auth.user.scopes;
export const getGatesFromAuth = state => state.auth.gates;
export const getEmailFromAuth = state => state.auth.user.email;
export const isApplicationHubless = state => !getPortalIdFromAuth(state);
export const isUserImpersonated = state => state.auth.user.acting_user_id > 0;